import { Component, ChangeDetectionStrategy, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { AiAdvancedSearchResponse } from "./s25.chatbot.service";
import { S25ChatbotComponent } from "./s25.chat.bot.component";

@TypeManagerDecorator("s25-ng-ai-search-chatbot")
@Component({
    selector: "s25-ng-ai-search-chatbot",
    template: `
        <s25-ng-ai-chatbot
            #chatbot
            [welcomeMessage]="
                'Provide details on what you are looking for and I can help you get started on a SeriesQL query.'
            "
            [mode]="'sidebar'"
            [title]="'AI Query Chat'"
            [windowMaxHeight]="'50vh'"
            [serviceConfig]="'advancedSearch'"
            (responseReceived)="onResponseReceived($event)"
        ></s25-ng-ai-chatbot>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, S25ChatbotComponent],
    standalone: true,
})
export class S25AiSearchChatbotComponent {
    @ViewChild("chatbot") chatbot!: S25ChatbotComponent<"advancedSearch">;

    constructor() {}

    replacePlaceholders(query: string): { cleanedQuery: string; hasPlaceholders: boolean } {
        let hasPlaceholders = false;

        const cleanedQuery = query.replace(/\(\w+\)/g, () => {
            hasPlaceholders = true;
            return "(PLACEHOLDER)";
        });

        return { cleanedQuery, hasPlaceholders };
    }

    onResponseReceived(response: AiAdvancedSearchResponse) {
        if (response.queryGrouping) {
            const { cleanedQuery, hasPlaceholders } = this.replacePlaceholders(response.queryGrouping);

            this.chatbot.aiStore.pushAction({ actionType: "searchQuery", payload: "::" + cleanedQuery });

            let message = `I've generated the following query:\n${cleanedQuery}`;
            if (hasPlaceholders) {
                message += `\n\nPlease fill out the placeholder values to complete your query.`;
            }

            this.chatbot.addResponse(message);
        } else {
            this.chatbot.addResponse(response.queryGrouping);
        }
    }
}
